import { createAction } from "../../Common/_actions/Action";
import { UserProductDesignPayload } from "../_stores/UserProductDesignStore";

export enum ProductDesignStoreActionType {
  EditProductDesign = 'PRODUCT_DESIGN_EDIT_PRODUCT_DESIGN',
  EditManyProductDesigns = 'PRODUCT_DESIGN_EDIT_MANY_PRODUCT_DESIGNS',
  RemoveProductDesign = 'PRODUCT_DESIGN_REMOVE_PRODUCT_DESIGN',
}

export const EditProductDesign = (productDesign: UserProductDesignPayload) => createAction(ProductDesignStoreActionType.EditProductDesign, {
  productDesign: productDesign
});

export const EditManyProductDesigns = (productDesigns: UserProductDesignPayload[]) => createAction(ProductDesignStoreActionType.EditManyProductDesigns, {
  productDesigns: productDesigns
});

export const RemoveProductDesign = (id: number) => createAction(ProductDesignStoreActionType.RemoveProductDesign, {
  id: id
});

export type ProductDesignStoreAction =
  ReturnType<typeof EditProductDesign> |
  ReturnType<typeof EditManyProductDesigns> |
  ReturnType<typeof RemoveProductDesign>